import type { Action } from "../../actions/types";

interface LoyaltyRewardPreview {
  amount: number;
  currency: string;
  rewardType: string;
}

export interface PDPPointsTotal {
  potentialRewards: LoyaltyRewardPreview[];
  loyaltyCurrency: string;
  error: boolean | null;
}

export type StoreState = PDPPointsTotal | null;

export const initialState: StoreState = null;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "PDP_POINTS_TOTAL_SUCCESS":
      return action.response.data as PDPPointsTotal;
    case "PDP_POINTS_TOTAL_FAILURE":
      return { ...state, potentialRewards: [], error: true } as PDPPointsTotal;
    default:
      return state;
  }
}
